var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArchiveIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3346 16.4089H1.80967V4.82258H0V0H20.137V4.79998H18.3346V16.4089ZM16.8243 14.9484V4.82514H3.30601V14.9484H16.8243ZM1.46428 3.31228H18.6572V1.46357H1.46428V3.31228Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3558 6.37396H6.77327C6.77327 6.78479 6.78361 7.17559 6.76914 7.5669C6.7619 7.76871 6.82084 7.83034 7.02766 7.8288C8.24169 7.81955 9.45779 7.82418 10.6703 7.82418H13.1247C13.2343 7.82418 13.3574 7.84883 13.3553 7.67012C13.3532 7.24337 13.3558 6.81714 13.3558 6.37396Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.356 6.37393C13.356 6.8171 13.356 7.24334 13.356 7.66957C13.356 7.84828 13.235 7.82363 13.1254 7.82363H10.6725C9.45799 7.82363 8.24242 7.819 7.02994 7.82825C6.82312 7.82825 6.7621 7.76817 6.77141 7.56635C6.78589 7.17504 6.77554 6.7827 6.77554 6.37341L13.356 6.37393Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchiveIcon);
export default __webpack_public_path__ + "static/media/archive_icon.a404df4a.svg";
export { ForwardRef as ReactComponent };